import type { AlphaDesignVersion } from "@nlc/shared-types";

export function versionSummary(version: AlphaDesignVersion): string {
  if (!version.edit) return "original";

  return (
    version.edit.instructions[0] ??
    version.edit.marks.find(({ instruction }) => instruction)?.instruction ??
    "edited"
  );
}
